import type Lenis from 'lenis'

// Module-level handle so the overlay menu can pause smooth scrolling without
// prop-drilling the instance through the whole tree.
let instance: Lenis | null = null

export const setLenis = (next: Lenis | null): void => {
    instance = next
}

export const lockScroll = (): void => {
    instance?.stop()
    document.body.classList.add('menu-open')
}

export const unlockScroll = (): void => {
    instance?.start()
    document.body.classList.remove('menu-open')
}
